import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { getLastSelectedAdvice } from '../../Utils/helpers';
import { Copy, X } from 'react-feather';
import '../../Styles/Annotator/AdvicesComponent.css';
import AdvicesComponent from './AdvicesComponent';

const AdviceSearchAnnotationModal = (props) => {
    const annotationData = props.annotationData
    const setAnnotationData = props.setAnnotationData;
    return (
        <div>
            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                Centered
                animation={false}
                backdrop="static"
                className={'adviceXLModal'}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">Select Advice</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AdvicesComponent handleClose={props.onHide}
                                      advicelist={props.advicelist}
                                      annotationData={annotationData}
                                      lvid={props.lvid}
                                      setAnnotationData={setAnnotationData}
					 />
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={() => {
                            getLastSelectedAdvice().then((r) => r);
                            props.onHide();
                        }}
                        size="lg"
                        variant="outline-success"
                    >
                        {' '}
                        <Copy /> &nbsp; Letzte kopieren
                    </Button>
                    &nbsp; &nbsp;
                    <Button size="lg" variant="outline-dark" onClick={props.onHide}>
                        {' '}
                        <X /> &nbsp; Abbrechen
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AdviceSearchAnnotationModal;
